import * as Yup from "yup";
import { API_END_POINT } from "../../constants";
import { InputField } from "../../components/form/input.field.component";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import { CheckboxField, CheckBoxStyle } from "../../core/checkbox-field.component";
import { Upload, UploadOnAddEvent } from '@progress/kendo-react-upload';
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { useEffect, useState } from "react";
import { useGetUoms } from "../../apiclient/product/useGetUOMApi";
import { SelectField } from "../../core/select-field.component";
import ProductTaxModel from "../../models/masters/producttax-model";
import { useGetProductTax } from "../../apiclient/master/useGetProductTaxApi";

interface ProductTaxEditProps {
    data: ProductTaxModel;
    isViewMode?: boolean;
    onClose?: (status: SubmitStatus, data: any) => any;
}

const ProductTaxEntry: React.FC<ProductTaxEditProps> = ({ ...props }) => {
    let { data, onClose,isViewMode } = props;
    const title = data?.productTaxId > 0 ? "Edit Product Tax" : "Add Product Tax";

    let initialValue: ProductTaxModel = {
        productTaxId: data?.productTaxId ? data.productTaxId : 0,
        taxName: data?.taxName,
        cgstPercentage: data?.cgstPercentage,
        sgstPercentage: data?.sgstPercentage,
        igstPercentage:data?.igstPercentage,
       
    };
    console.log(initialValue)
    const validationSchema = Yup.object().shape({
        taxName: Yup.string().required("Required"),       
        // name: Yup.string()
        // .required("Required")
        // .test("check-duplicate-name", "ProductTax name already exists", (value) => {
        //   return (
        //     value &&
        //     !existingName.includes(value) ||
        //     (data?.taxName && value === data.taxName) // Allow current name during update
        //   );
        // }),


    });

    const [existingName, setExistingName] = useState<string[]>([]); // state to hold existing zone names
    const { data: fetchedProductTax } = useGetProductTax(); // Fetching existing zones data

    useEffect(() => {
        if (fetchedProductTax) {
            setExistingName(fetchedProductTax.map((zone: any) => zone.name)); // Extracting zone names to compare against
        }
    }, [fetchedProductTax]);

    

    return (
        <>
            <FormikModelDialog
                width="50%"
                title={title}
                initialData={initialValue}
                validationSchema={validationSchema}
                show={!!data}
                onClose={onClose}
                endpoint={API_END_POINT.PRODUCT}
                postRoute="ProductTax/SaveProductTax"
                showAddAnother={true}
                isViewOnly ={isViewMode}
                isUpDateEntityDetails={data?.productTaxId > 0 ? true : false}

            >
                <div>
                    <div className="row">
                        <div className="col-4">
                            <InputField maxLength={100} label="ProductTax *" name="taxName" />
                        </div>
                        <div className="col-6">
                            <InputField maxLength={100} label="CGST (%) " name="cgstPercentage" />
                        </div>
                        <div className="col-6">
                            <InputField maxLength={100} label=" SGST (%)" name="sgstPercentage" />
                        </div>
                        <div className="col-6">
                            <InputField maxLength={100} label="IGST (%)" name="igstPercentage" />
                        </div>
                    </div>

                    


                </div>
            </FormikModelDialog >
        </>
    );
};

export default ProductTaxEntry;
